// UI simulation only. This is not evidence of a real advertising reward.
export function showTestRewardedAd({ dialog, progress, status, formatStatus, isVisible = () => !document.hidden, duration = 5000 }) {
  return new Promise(resolve => {
    let elapsed = 0;
    let previous = performance.now();
    let settled = false;
    let timer;
    const finish = completed => {
      if (settled) return;
      settled = true;
      clearInterval(timer);
      dialog.removeEventListener('close', cancelled);
      dialog.removeEventListener('cancel', cancelled);
      if (dialog.open) dialog.close();
      resolve(completed);
    };
    const cancelled = () => finish(false);
    const paint = () => {
      progress.value = elapsed;
      status.textContent = formatStatus(Math.ceil((duration - elapsed) / 1000));
    };
    progress.max = duration;
    paint();
    dialog.addEventListener('close', cancelled);
    dialog.addEventListener('cancel', cancelled);
    dialog.showModal();
    timer = setInterval(() => {
      if (!dialog.open) { finish(false); return; }
      const now = performance.now();
      if (isVisible()) elapsed = Math.min(duration, elapsed + Math.min(now - previous, 250));
      previous = now;
      paint();
      if (elapsed >= duration) finish(true);
    }, 100);
  });
}
